import axios from 'axios';

// Direct axios configuration for chat.realestate
const getApiBaseUrl = (): string => {
  // Check if we're in production
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // Production: Use relative URLs
    return '/api/';
  }
  
  // Localhost development: Direct connection to backend
  return 'http://localhost:8080/api/';
};

const baseURL = getApiBaseUrl();
const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

console.log(`🔧 [API] Environment: ${window.location.hostname}, Using baseURL: ${baseURL}`);

// Add request interceptor for debugging
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('🌐 [API] Making request to:', config.url);

    // Log POST request bodies for debugging
    if (config.method === 'post' && config.data) {
      console.log('📤 [API] Request body:', config.data);
    }

    // Let axios auto-detect Content-Type for FormData (multipart/form-data)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // Add JWT token to Authorization header if available
    const token = localStorage.getItem('auth_token') || localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔐 [API] Added Bearer token to request');
    } else {
      console.warn('⚠️ [API] No auth token found in localStorage');
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('✅ [API] Response received:', response.status, response.config?.url);
    return response;
  },
  async (error) => {
    console.error('❌ [API] Request failed:', error.response?.status, error.config?.url, error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
